import { Controller } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import type { ReactNode } from "react";
import type { Control, FieldValues, Path, RegisterOptions } from "react-hook-form";

// Lista de entidades genérica: solo se usa `id` (value) y una clave de texto
// (`description`/`name`) según el caso de uso. No se importa el DTO real de cada
// call site para no acoplar este componente tonto a un dominio específico.
export interface EntityOption {
  id?: number | string;
  [key: string]: unknown;
}

export interface EntitySelectProps<T extends FieldValues = FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
  rules?: RegisterOptions<T>;
  defaultValue?: unknown;
  listValue?: EntityOption[] | null;
  labelKey?: string;
}

// Select genérico (tonto) para listas de entidades. Reemplaza a SelectActivity,
// SelectTypeOfCharge, SelectAssignedProject y SelectIssues, que eran el mismo
// componente con distinta key de etiqueta (`description` vs `name`).
export const EntitySelect = <T extends FieldValues = FieldValues,>({
  control,
  name,
  label,
  rules,
  defaultValue,
  listValue,
  labelKey = "description",
}: EntitySelectProps<T>) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue as never}
    rules={rules}
    render={({ field }) => (
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select {...field} label={label} defaultValue={defaultValue as never}>
          {listValue?.map((option) => (
            <MenuItem value={option.id} key={option.id}>
              {option[labelKey] as ReactNode}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
  />
);
